import { Component, OnInit } from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { InSalesService } from '../../../shared/services/inventory/in-sales.service'
import { DataService } from '../../services/data.service'
export interface ContactHistoryModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-salescontacthistory',
  templateUrl: './salescontacthistory.component.html',
  styleUrls: ['./salescontacthistory.component.css']
})
export class SalescontacthistoryComponent extends DialogComponent<ContactHistoryModel, boolean> implements ContactHistoryModel, OnInit {
  title: string;
  data: any = []
  fullData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  loading: boolean = false;
  f: any = {
    InvNo: "",
    Invdate: "",
    TotAmount: "",
    Location: ""
  };
  constructor(dialogService: DialogService, private ds: DataService, private sa: InSalesService) { super(dialogService); }

  ngOnInit() {
    this.fullData = this.data
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    // this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    // document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "InvNo":
          this.f.InvNo = e.target.value;
          break;
        case "InvDate":
          this.f.InvDate = e.target.value;
          break;
        case "TotAmount":
          this.f.TotAmount = e.target.value;
          break;
        case "Location":
          this.f.Location = e.target.value;
          break;
      }
      this.selectedRow = 0;
      var filter: any = {
        PhoneNo: this.fullData.PhoneNo,
        RequestedList: {
          Start: 0,
          FiterText: "",
          Limit: this.ds.Settings.MaxLimit,
          ItemTypeId: this.ds.Settings.ItemTypeId,
          CAType: this.ds.Settings.CAType
        }
      }
      this.sa.getSalescontactHistory(filter).subscribe(res => {
        if (res.Success) {
          this.fullData = res.data
        }
      });
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      // this.selecedItem();
    }
    else return;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/salescontacthistory/salescontacthistory.component.ts